/**
 * Pre-seeded pickup requests so the demo dashboard is never empty on first load.
 * Dates are generated relative to today so the demo never looks stale.
 */

const daysFromNow = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

const hoursAgo = (hours) => new Date(Date.now() - hours * 3600 * 1000).toISOString();

export const seedRequests = [
  {
    id: 'EW-2026-1042',
    company: 'Northwind Systems Pvt. Ltd.',
    contactPerson: 'Meera Krishnan',
    email: 'meera.k@northwind.example',
    phone: '+91 98450 22110',
    address: 'Tower B, Embassy Tech Village, Outer Ring Road, Bengaluru 560103',
    categories: ['it-equipment', 'networking'],
    quantity: 1850,
    unit: 'kg',
    pickupDate: daysFromNow(4),
    notes: '412 laptops and 60 switches. Data destruction certificates required per serial.',
    status: 'Scheduled',
    createdAt: hoursAgo(52),
  },
  {
    id: 'EW-2026-1038',
    company: 'Axis Finserv Limited',
    contactPerson: 'Arvind Menon',
    email: 'a.menon@axisfinserv.example',
    phone: '+91 99300 47821',
    address: 'Regional Office, Nariman Point, Mumbai 400021',
    categories: ['it-equipment', 'printers', 'batteries'],
    quantity: 3.2,
    unit: 'MT',
    pickupDate: daysFromNow(9),
    notes: 'Consolidated pickup across 6 branches. Form 6 must be issued per branch.',
    status: 'Verified',
    createdAt: hoursAgo(20),
  },
  {
    id: 'EW-2026-1031',
    company: 'Core9 Datacentres',
    contactPerson: 'Priya Nambiar',
    email: 'priya.nambiar@core9.example',
    phone: '+91 98110 65432',
    address: 'DC-3, Sector 62, Noida, Uttar Pradesh 201309',
    categories: ['servers', 'cables'],
    quantity: 214,
    unit: 'units',
    pickupDate: daysFromNow(-6),
    notes: 'Two rack rows decommissioned. On-site shredding was witnessed by our security team.',
    status: 'Certified',
    createdAt: hoursAgo(360),
  },
  {
    id: 'EW-2026-1027',
    company: 'Helios Manufacturing Co.',
    contactPerson: 'Kavita Rao',
    email: 'kavita.rao@heliosmfg.example',
    phone: '+91 97020 11845',
    address: 'Plant 2, Ranjangaon MIDC, Pune, Maharashtra 412220',
    categories: ['industrial', 'batteries'],
    quantity: 5.6,
    unit: 'MT',
    pickupDate: daysFromNow(-2),
    notes: 'Legacy control panels from Line 3. Dismantling done on site by your crew.',
    status: 'Collected',
    createdAt: hoursAgo(210),
  },
  {
    id: 'EW-2026-1019',
    company: 'Verta Healthcare Group',
    contactPerson: 'Dr. Imran Qureshi',
    email: 'i.qureshi@vertahealth.example',
    phone: '+91 90040 78123',
    address: 'Biomedical Wing, Verta Hospital, Banjara Hills, Hyderabad 500034',
    categories: ['medical', 'it-equipment'],
    quantity: 940,
    unit: 'kg',
    pickupDate: daysFromNow(6),
    notes: 'Two decommissioned analysers. Patient data sanitisation needed before removal.',
    status: 'Submitted',
    createdAt: hoursAgo(5),
  },
];

export default seedRequests;
